/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.getConvoForMembers'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  members: /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'did' }), {
    maxLength: 10,
    minLength: 1,
  }),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  convo: /*#__PURE__*/ l.ref<ConvoDefs.ConvoView>(
    (() => ConvoDefs.convoView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get or create a 1-1 conversation for the given members. Always returns the same direct (non-group) conversation. To create a group conversation, use createGroup. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, [
  'AccountSuspended',
  'BlockedActor',
  'BlockedSubject',
  'MessagesDisabled',
  'NotFollowedBySender',
  'RecipientNotFound',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
